module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.storeMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 1
      }
    }
  }, [_c('a', [_vm._v("基本資訊")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 2
      }
    }
  }, [_c('a', [_vm._v("細部設定")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 3
      }
    }
  }, [_c('a', [_vm._v("預訂/訂購時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 4
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 4
      }
    }
  }, [_c('a', [_vm._v("付款方式")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 5
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 5
      }
    }
  }, [_c('a', [_vm._v("製作/取餐時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 6
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 6
      }
    }
  }, [_c('a', [_vm._v("取餐方式/門檻")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 7
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 7
      }
    }
  }, [_c('a', [_vm._v("營業/公休時間")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 8
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 8
      }
    }
  }, [_c('a', [_vm._v("塑膠袋")])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', {
    class: {
      'active': _vm.storeMethod == 10
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 10
      }
    }
  }, [_c('a', [_vm._v("出單機")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 98
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 98
      }
    }
  }, [_c('a', [_vm._v("排除商品")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 99
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 99
      }
    }
  }, [_c('a', [_vm._v("連線紀錄")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.storeMethod == 15
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.storeMethod = 15
      }
    }
  }, [_c('a', [_vm._v("特殊需求")])])])]), _vm._v(" "), (_vm.storeMethod === 1) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body m-b-10"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-store-info",
    attrs: {
      "src": _vm.storeInfo.image
    }
  }), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱 (ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.name) + " (" + _vm._s(_vm.storeInfo.id) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("縮寫名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.name_short) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("所屬品牌 (ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.brand_name) + " (" + _vm._s(_vm.storeInfo.brand_id) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("所屬群組 (ID)")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.store_group_name) + " (" + _vm._s(_vm.storeInfo.store_group_id) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                城市 (代碼)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.city_name) + " (" + _vm._s(_vm.storeInfo.city_code) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                區域 (代碼)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.area_name) + " (" + _vm._s(_vm.storeInfo.area_code) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                地址 (x, y)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.address) + " (" + _vm._s(_vm.storeInfo.longitude) + ", " + _vm._s(_vm.storeInfo.latitude) + ")\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                電話\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.tel) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.tel2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                電話2\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.tel2) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.email) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                電子信箱\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.email) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.youtube_video_code) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  Youtube影片代碼\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.youtube_video_code) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [(_vm.storeInfo.ein) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                統一編號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.ein) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.bl_name) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                抬頭\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.bl_name) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                描述\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.description) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.search_description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                描述(搜尋引擎顯示)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.search_description) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.introduction) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市頁介紹\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.storeInfo.introduction)
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.branch_code) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                品牌下店家代碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.branch_code) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.pos_branch_code) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                POS的店家代碼\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.pos_branch_code) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                最後更新時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.edit_time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                建立時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.create_time) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.photo) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                底圖\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('img', {
    staticStyle: {
      "max-height": "100px"
    },
    attrs: {
      "src": _vm.storeInfo.photo
    }
  })])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.meal_tag_info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  餐點種類\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.meal_tag_info), function(mealSetting) {
    return _c('span', {
      staticClass: "label label-success m-b-5 m-r-5"
    }, [_vm._v(_vm._s(mealSetting.name))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 2) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                API服務類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.api_type === 1) ? _c('span', [_vm._v("專屬客製POS")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.api_type === 2) ? _c('span', [_vm._v("公版POS")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.api_type === 3) ? _c('span', [_vm._v("平板接單")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                門市類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.store_type === 0) ? _c('span', [_vm._v("未分類")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.store_type === 1) ? _c('span', [_vm._v("直營")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.store_type === 2) ? _c('span', [_vm._v("加盟")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                距離計算模式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.distance_service_model === 11) ? _c('span', [_vm._v("走路模式(WALKING)")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.distance_service_model === 12) ? _c('span', [_vm._v("開車模式(DRIVING)")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.distance_service_model === 13) ? _c('span', [_vm._v("機車(SCOOTER)")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.distance_service_model === 14) ? _c('span', [_vm._v("大眾運輸(TRANSIT)")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                營業狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.status === 2) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.getStateName(_vm.storeInfo.status)))]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.getStateName(_vm.storeInfo.status)))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                條碼類型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.barcodeTypeName(_vm.storeInfo.barcode_type)) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                金額進位\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.roundTypeName(_vm.storeInfo.rounding_type)) + "\n                ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                優惠券形式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.couponFormName(_vm.storeInfo.coupon_form)) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  開放紙本發票\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.has_invoice_paper) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.has_invoice_paper) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("停用")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  開放電子載具\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.has_invoice_carrier) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.has_invoice_carrier) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("停用")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  發票備註\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.invoice_remark) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  開放愛心捐贈發票\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.has_invoice_npoban) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.has_invoice_npoban) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("停用")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  店家是否開發票\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(!_vm.storeInfo.is_invoice_exception) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開發票")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.is_invoice_exception) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("免開發票")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                前端顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_visible) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("顯示")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.is_visible) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未顯示")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                首頁是否搜尋的到店家\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_search) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("可搜尋")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.is_search) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不可搜尋")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                支援客製餐點貼紙\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_support_custom_sticker) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("支援")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.is_support_custom_sticker) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不支援")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                單品備註\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('span', {
    class: ['label', _vm.storeInfo.is_support_custom_remark ? 'label-success' : 'label-danger']
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.is_support_custom_remark ? '啟用' : '停用') + "\n                  ")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    domProps: {
      "textContent": _vm._s('單品備註')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info",
    domProps: {
      "textContent": _vm._s(_vm.storeInfo.custom_sticker_max_length)
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body  form-center"
  }, [_c('h3', [_vm._v("門市下訂金額限制")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                單筆最高上限\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.one_order_max_money) + " 元\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                到店付款(現金)單筆訂單最高上限\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.to_store_pay_max_money) + " 元\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("菜單呈現設定")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單版型\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info",
    domProps: {
      "textContent": _vm._s(_vm.menuLayout(_vm.storeInfo.menu_layout_type))
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                飲料溫度顯示(冷 熱 無溫度)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(!_vm.storeInfo.show_menu_icon) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("全部顯示")]) : (_vm.storeInfo.show_menu_icon === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("無溫度顯示冷")]) : (_vm.storeInfo.show_menu_icon === 2) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("皆顯示無溫度")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單產品圖示顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.show_menu_product_icon) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("顯示")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不顯示")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單當日停賣樣式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.menu_stop_sale_today_type === 1) ? _c('span', [_vm._v("顯示當日停賣ICON")]) : _c('span', [_vm._v("隱藏當日停賣商品")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單永久停賣樣式\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.menu_stop_sale_type === 1) ? _c('span', [_vm._v("顯示永久停賣ICON")]) : _c('span', [_vm._v("隱藏永久停賣商品")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單編輯權限\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.allow_update_menu === 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                銷售折扣組合(紅配綠)菜單分類顯示\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.menu_ab_block_type) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單同步權限\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.allow_copy_menu === 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")])])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 3) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body  form-center"
  }, [_c('h3', [_vm._v("預訂設定")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                開始預訂(距今日幾天，0為當日)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_start_day) + " 天\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                結束預訂(距開始預訂幾天，0為開始預訂日)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_tolerance_day) + " 天\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                 自動拒絕預約單時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.auto_reject_order_reserve_m) + " 分\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("接單/送單設定")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                接單狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.order_status == 10) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.order_status)))]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.order_status == 20) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.order_status)))]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.order_status_reason) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  暫停接單理由\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_status_reason) + "\n                ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                系統設定接單狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.system_order_status == 0) ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.system_order_status)))]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.system_order_status == 10) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.system_order_status)))]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.system_order_status == 20) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.orderStatusName(_vm.storeInfo.system_order_status)))]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                觸發系統自動設定的原因\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.systemReasonName) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                自動拒絕接單\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.auto_reject_order_m) + " 分\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                當日訂購時間前下單\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_preparing_allow_order === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("可下單")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不可下單")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                結束訂購時間後下單\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_close_allow_order === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("可下單")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不可下單")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                距營業方開始可以訂購時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_start_time_m) + " 分\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                距營業結束方可最後訂購時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.order_end_time_m) + " 分\n                ")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 4) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("支援")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("金流帳戶統一編號")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.trade_info), function(pay, index) {
    return (pay.is_valid) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(pay.name) + "\n                    ")]), _vm._v(" "), _c('td', [(pay.is_support) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("支援")]) : _vm._e(), _vm._v(" "), (!pay.is_support) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不支援")]) : _vm._e(), _vm._v(" "), (pay.use_key) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已設定")]) : _vm._e()]), _vm._v(" "), _c('td', [(pay.is_enable) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("使用")]) : _vm._e(), _vm._v(" "), (!pay.is_enable) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不使用")]) : _vm._e(), _vm._v(" "), (pay.use_key) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已設定")]) : _vm._e()]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('td', [_vm._v(_vm._s(pay.ein))]) : _vm._e()]) : _vm._e()
  }), 0)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("內用-桌邊掃碼")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("payAfterMeal")(_vm.storeInfo.delivery_way_custom_config[21].is_cash_pay_after_meal)))])])])])]), _vm._v(" "), (_vm.exceptionTradeList.length) ? _c('div', [_c('h3', [_vm._v("付款方式與取餐金額")])]) : _vm._e(), _vm._v(" "), (_vm.exceptionTradeList.length) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.exceptionTradeList), function(exceptionTrade, eIndex) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(_vm._f("deliveryName")(exceptionTrade.delivery_type)) + "\n                    "), (exceptionTrade.start_money) ? _c('span', [_vm._v("\n                      " + _vm._s(exceptionTrade.start_money) + " 元以上\n                    ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.start_money && exceptionTrade.end_money) ? _c('span', [_vm._v("\n                      ～\n                    ")]) : _vm._e(), _vm._v(" "), (exceptionTrade.end_money) ? _c('span', [_vm._v("\n                      " + _vm._s(exceptionTrade.end_money) + " 元以下\n                    ")]) : _vm._e(), _vm._v("\n                    不可用" + _vm._s(_vm._f("tradeName")(exceptionTrade.trade_type)) + "付款\n                  ")])])
  }), 0)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 5) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.take_time_info), function(take, index) {
    return (!_vm.hidePickupType.includes(take.take_type)) ? _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                        " + _vm._s(_vm.getDeliveryName(take.take_type)) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(take.prepare_time_seg) + " 分")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(take.take_time_seg) + " 分")])]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, _vm._l((_vm.storeInfo.process_time_info), function(process, pIndex) {
    return _c('div', {
      staticClass: "m-t-10 process-time-block"
    }, [_c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                  時間\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_vm._v("\n                    " + _vm._s(process.month) + " 月  \n                    "), (_vm.getTimeValue(process.start_value, process.value_type) && _vm.getTimeValue(process.end_value, process.value_type)) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.getTimeValue(process.start_value, process.value_type)) + " ~ " + _vm._s(_vm.getTimeValue(process.end_value, process.value_type)) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                    取餐類型\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "form-control form-info"
    }, [_vm._v("\n                    " + _vm._s(_vm.getDeliveryName(process.delivery_type)) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_vm._m(6, true), _vm._v(" "), _c('tbody', _vm._l((process.item_list), function(item, iIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(item.start_time) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.end_time) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.process_time) + " 分\n                  ")])])
    }), 0)])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 6) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.delivery_info), function(delivery, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.getDeliveryName(delivery.delivery_type)))]), _vm._v(" "), _c('td', [(delivery.is_support) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("支援")]) : _vm._e(), _vm._v(" "), (!delivery.is_support) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不支援")]) : _vm._e()]), _vm._v(" "), _c('td', [(delivery.is_enable) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!delivery.is_enable) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("關閉")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.is_default ? 'V' : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_distance_m) + "\n                      "), (delivery.delivery_type !== 3) ? _c('span', [_vm._v("(最低)")]) : _vm._e(), _vm._v(" "), (delivery.delivery_type === 3) ? _c('span', [_vm._v("(最高)")]) : _vm._e()]), _vm._v(" "), _c('td', [(delivery.delivery_type === 21 && (_vm.storeInfo.delivery_way_custom_config || _vm.subDeliveryType)) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("subDeliveryType")(_vm.storeInfo.delivery_way_custom_config[21].sub_delivery_type)) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('td', [(delivery.is_allow_guest_order) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!delivery.is_allow_guest_order) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("關閉")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showMemo(delivery.delivery_type, 'memo')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.showMemo(delivery.delivery_type, 'pickup_memo')))])])
  }), 0)])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                 外送最大距離 (單位: 公里)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("km")(_vm.storeInfo.max_delivery_distance_m)) + "\n                  "), (!_vm.storeInfo.max_delivery_distance_m) ? _c('span', [_vm._v("無限制")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.delivery_exception_product_info), function(item, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.product_type === 3 ? '套餐' : '商品'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vendor_custom_id))]), _vm._v(" "), _c('td', [(item.is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!item.is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("關閉")]) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.shippingInfo.is_support && _vm.shippingInfo.is_enable) ? _c('div', [(_vm.storeInfo.shipping_description) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("運費說明")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.shipping_description) + "\n                  ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("運費計算")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.shipping_fee_type == 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不計算運費")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type == 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("依訂單金額計算")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type == 2) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("依運送距離計算")]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type == 3) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("依運送距離+訂單金額計算")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.shipping_fee_normal_info.vendor_custom_id) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.shipping_fee_normal_info.vendor_custom_id) + "\n                  ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type === 1) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', [_vm._l((_vm.showItemList), function(item, iIndex) {
    return (item.money && item.money !== null) ? _c('tr', [_c('td', [_vm._v("\n                    $ " + _vm._s(iIndex ? _vm.showItemList[iIndex - 1].money + 1 : 0) + " ～ $ " + _vm._s(item.money) + "\n                  ")]), _vm._v(" "), _c('td', [(item.fee) ? _c('span', [_vm._v("運費 $ " + _vm._s(item.fee))]) : _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("免運")])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [(!_vm.showItemList.length || !_vm.showItemList[_vm.showItemList.length - 2] || !_vm.showItemList[_vm.showItemList.length - 2].money) ? _c('span', [_vm._v("不限金額")]) : _c('span', [_vm._v("$ " + _vm._s(_vm.showItemList[_vm.showItemList.length - 2].money + 1) + " 以上")])]), _vm._v(" "), _c('td', [(_vm.getShippingMaxFee) ? _c('span', [_vm._v("運費 $ " + _vm._s(_vm.getShippingMaxFee))]) : _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("免運")])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type === 2) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(14), _vm._v(" "), _c('tbody', _vm._l((_vm.showItemList), function(item, iIndex) {
    return _c('tr', [_c('td', [(_vm.showItemList.length <= 1 && item.distance === null) ? [_vm._v("\n                      不限距離\n                    ")] : (_vm.showItemList.length > 1 && item.distance === null) ? [_vm._v("\n                      " + _vm._s(_vm._f("km")(_vm.numeral(_vm.showItemList[iIndex - 1].distance).add(100).value())) + " 公里以上\n                    ")] : [_vm._v("\n                      " + _vm._s(_vm._f("km")((_vm.showItemList[iIndex - 1] ? _vm.numeral(_vm.showItemList[iIndex - 1].distance).add(100).value() : 0))) + " 公里 ～ " + _vm._s(_vm._f("km")(item.distance)) + " 公里\n                    ")]], 2), _vm._v(" "), _c('td', [(item.fee) ? _c('span', [_vm._v("運費 $" + _vm._s(item.fee))]) : _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("免運")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.shipping_fee_type === 3) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable delivery-table"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', [_vm._l((_vm.showItemList), function(item, index) {
    return [_c('tr', {
      class: index % 2 ? 'even' : 'odd'
    }, [_c('td', {
      attrs: {
        "rowspan": item.range.length + 1
      }
    }, [(_vm.showItemList.length <= 1 && item.distance == null) ? [_c('span', [_vm._v("\n                            不限距離\n                          ")])] : (_vm.showItemList.length > 1 && item.distance == null) ? [_vm._v("\n                          " + _vm._s(_vm._f("km")(_vm.numeral(_vm.showItemList[index - 1].distance).add(100).value())) + " 公里以上\n                        ")] : [_vm._v("\n                          " + _vm._s(_vm._f("km")((_vm.showItemList[index - 1] ? _vm.numeral(_vm.showItemList[index - 1].distance).add(100).value() : 0))) + " 公里 ～ " + _vm._s(_vm._f("km")(item.distance)) + " 公里\n                        ")]], 2)]), _vm._v(" "), _vm._l((item.range), function(range, idx) {
      return _c('tr', {
        class: index % 2 ? 'even' : 'odd'
      }, [_c('td', [(idx !== item.range.length - 1) ? _c('span', [_vm._v("$ " + _vm._s(idx ? item.range[idx - 1].money + 1 : 0) + " ～ $ " + _vm._s(range.money))]) : _c('span', [_vm._v("$ " + _vm._s(item.range[idx - 1].money + 1) + " 以上")])]), _vm._v(" "), _c('td', [(range.fee) ? _c('span', [_vm._v("運費 $ " + _vm._s(range.fee))]) : _c('span', {
        staticClass: "text-danger"
      }, [_vm._v("免運")])])])
    })]
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showTableNumber) ? [_vm._m(16), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  桌號必填\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.delivery_way_custom_config[21].is_table_no_required ? '必填' : '非必填') + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  桌號編輯\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.delivery_way_custom_config[21].is_table_no_editable ? '可' : '不可') + "編輯\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  桌號顯示\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.storeInfo.delivery_way_custom_config[21].show_table_no ? '顯示' : '隱藏') + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.exceptionCalendar.length) ? _c('div', [_c('h3', [_vm._v("排除設定")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.exceptionCalendar), function(exCalendar, caIndex) {
    return _c('div', {
      staticClass: "m-t-10"
    }, [_c('table', {
      staticClass: "table table-bordered table-striped dataTable"
    }, [_c('thead', {
      staticClass: "bg-primary"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("deliveryName")(exCalendar.delivery_type)))])])]), _vm._v(" "), _c('tbody', [_vm._l((exCalendar.date_type), function(item, daIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(item.date) + " " + _vm._s(item.start_time) + " ~ " + _vm._s(item.end_time) + " 不可" + _vm._s(_vm._f("deliveryName")(exCalendar.delivery_type)) + "\n                  ")])])
    }), _vm._v(" "), _vm._l((exCalendar.week_day), function(weItem, weIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    週" + _vm._s(_vm.getDayName(weItem.day)) + " " + _vm._s(weItem.start_time) + " ~ " + _vm._s(weItem.end_time) + " 不可" + _vm._s(_vm._f("deliveryName")(exCalendar.delivery_type)) + "\n                  ")])])
    }), _vm._v(" "), _vm._l((exCalendar.month_day), function(moItem, moIndex) {
      return _c('tr', [_c('td', [_vm._v("\n                    每月" + _vm._s(moItem.day) + "號 " + _vm._s(moItem.start_time) + " ~ " + _vm._s(moItem.end_time) + " 不可" + _vm._s(_vm._f("deliveryName")(exCalendar.delivery_type)) + "\n                  ")])])
    })], 2)])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 7) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body  form-center"
  }, [_c('h3', [_vm._v("營業時間")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(17), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.opening_info), function(open, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("星期" + _vm._s(_vm.getDayName(open.week_day)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.start_time) + " ～ " + _vm._s(open.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.order_start_time) + " ～ " + _vm._s(open.order_end_time))])])
  }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.specialOpenTime), function(open, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', _vm._l((open.calendarList), function(date, index) {
      return _c('span', [_vm._v(_vm._s(date)), (index < open.calendarList.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.start_time) + " ～ " + _vm._s(open.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.order_start_time) + " ～ " + _vm._s(open.order_end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.remark))])])
  }), 0)])])]), _vm._v(" "), _c('h3', [_vm._v("公休時間")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  公休時間下單\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_off_allow_order === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("可下單")]) : _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("不可下單")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.offday_info.date.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  指定日期\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.offday_info.date), function(offDate, odIndex) {
    return _c('span', [_vm._v(_vm._s(offDate)), (odIndex < _vm.storeInfo.offday_info.date.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.offday_info.week_day.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  每週幾\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.offday_info.week_day), function(offWeek, owIndex) {
    return _c('span', [_vm._v(_vm._s(_vm.getWeek(offWeek))), (owIndex < _vm.storeInfo.offday_info.week_day.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.storeInfo.offday_info.month_day.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  每月幾號\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.offday_info.month_day), function(offMonth, omIndex) {
    return _c('span', [_vm._v(_vm._s(offMonth) + "日"), (omIndex < _vm.storeInfo.offday_info.month_day.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 8) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body  form-center"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("塑膠袋功能")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.plastic_option) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.plastic_option) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("塑膠袋數量可自行調整")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.is_plastic_amount_adjustable) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.is_plastic_amount_adjustable) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("塑膠袋單位")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeInfo.plastic_unit) + "個餐點 → 1個塑膠袋\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.storeInfo.delivery_way_plastic_selected) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("預設勾選塑膠袋")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.storeInfo.delivery_way_plastic_selected), function(defaultP) {
    return _c('span', {
      staticClass: "label label-success m-b-5 m-r-5"
    }, [_vm._v(_vm._s(_vm._f("deliveryName")(defaultP)))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeMethod === 10),
      expression: "storeMethod === 10"
    }],
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(19), _vm._v(" "), _c('tbody', [(!_vm.printerStoreList.length) ? _c('tr', {
    staticClass: "text-center"
  }, [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("無出單機")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.printerStoreList), function(printer, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                    出單機" + _vm._s(printer.printer_id) + "號 (" + _vm._s(printer.printer_id) + ")\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(printer.binding_name) + " (" + _vm._s(printer.binding_id) + ")\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.printerType(printer.printer_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(printer.printer_identity))]), _vm._v(" "), _c('td', [(printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.printer_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [(printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!printer.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('br')])])]), _vm._v(" "), (_vm.storeMethod === 98) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "box-body  form-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, _vm._l((_vm.storeInfo.delivery_exception_items_info), function(value, key) {
    return _c('table', {
      staticClass: "table table-bordered table-striped dataTable",
      staticStyle: {
        "border": "0px"
      },
      attrs: {
        "aria-describedby": "example1_info",
        "role": "grid"
      }
    }, [_vm._l((value), function(category, cKey) {
      return (value.adjust.length || value.block.length || value.category.length || value.combination.length ||
        value.option.length || value.package.length || value.product.length) ? _c('thead', [(category.length) ? _c('tr', {
        attrs: {
          "role": "row"
        }
      }, [_c('th', {
        attrs: {
          "colspan": "2",
          "rowspan": "1",
          "aria-controls": "example1",
          "tabindex": "0"
        }
      }, [_vm._v(_vm._s(_vm._f("deliveryName")(parseInt(key, 10))) + "排除")]), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "1",
          "rowspan": "1",
          "aria-controls": "example1",
          "tabindex": "0"
        }
      }, [_vm._v("POS料號")])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((value), function(category, cKey) {
      return (value.adjust.length || value.block.length || value.category.length || value.combination.length ||
        value.option.length || value.package.length || value.product.length) ? _c('tbody', {
        staticStyle: {
          "border": "1px solid gray"
        }
      }, _vm._l((category), function(item) {
        return _c('tr', {
          staticClass: "even",
          attrs: {
            "role": "row"
          }
        }, [_c('td', [_vm._v(_vm._s(_vm.getCategoryName(cKey)))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(item.name) + " (" + _vm._s(item.item_id) + ")\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(item.vendor_custom_id) + "\n                    ")])])
      }), 0) : _vm._e()
    })], 2)
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 99) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body  form-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(21), _vm._v(" "), _c('tbody', [_vm._l((_vm.storeInfo.mqtt_info), function(mqtt, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(_vm.getTime(mqtt.create_time)) + "\n                    ")]), _vm._v(" "), _c('td', [(mqtt.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("連線")]) : _vm._e(), _vm._v(" "), (mqtt.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("中斷")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.storeInfo.mqtt_info) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("無任何連線紀錄")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.storeMethod === 15) ? _c('div', {
    staticClass: "box-body"
  }, [(_vm.storeInfo.store_special_item_setting && Array.isArray(_vm.storeInfo.store_special_item_setting) && _vm.storeInfo.store_special_item_setting.length > 0) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("自選吸管或餐具功能")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.store_special_item_setting[0].is_show) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.store_special_item_setting[0].is_show) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("預設吸管或餐具選項")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.storeInfo.store_special_item_setting[0].default_value) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("開啟")]) : _vm._e(), _vm._v(" "), (!_vm.storeInfo.store_special_item_setting[0].default_value) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("關閉")]) : _vm._e()])]), _vm._v(" "), _c('br')])]) : _c('div', {
    staticClass: "box-body form-center"
  }, [_vm._m(22), _vm._v(" "), _vm._m(23)])]) : _vm._e()])]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "openModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "營業時間")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(25), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.opening_info), function(open, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("星期" + _vm._s(_vm.getDayName(open.week_day)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.start_time) + " ～ " + _vm._s(open.end_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(open.order_start_time) + " ～ " + _vm._s(open.order_end_time))])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "deliveryModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "外送門檻")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(26), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.delivery_info), function(delivery, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.getDeliveryName(delivery.delivery_type)))]), _vm._v(" "), _c('td', [(delivery.is_support) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("使用")]) : _vm._e(), _vm._v(" "), (!delivery.is_support) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不使用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(delivery.order_min_distance_m) + "\n                      "), (delivery.delivery_type !== 3) ? _c('span', [_vm._v("(最低)")]) : _vm._e(), _vm._v(" "), (delivery.delivery_type === 3) ? _c('span', [_vm._v("(最高)")]) : _vm._e()])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "payModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "付款方式")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(27), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.trade_info), function(pay, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(pay.name) + "\n                    ")]), _vm._v(" "), _c('td', [(pay.is_enable) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("使用")]) : _vm._e(), _vm._v(" "), (!pay.is_enable) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("不使用")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pay.id))])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "takeTimeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "製作/取餐時間")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(28), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.take_time_info), function(take, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(_vm.getDeliveryName(take.take_type)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(take.prepare_time_seg) + " 分")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(take.take_time_seg) + " 分")])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "mqttModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.storeInfo.name) + "今日連線紀錄")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(29), _vm._v(" "), _c('tbody', _vm._l((_vm.storeInfo.mqtt_info), function(mqtt, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                      " + _vm._s(_vm.getTime(mqtt.create_time)) + "\n                    ")]), _vm._v(" "), _c('td', [(mqtt.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("連線")]) : _vm._e(), _vm._v(" "), (mqtt.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("中斷")]) : _vm._e()])])
  }), 0)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('h3', [_vm._v("細部設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("付款方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("現金付款設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("取餐方式")]), _vm._v(" "), _c('td', [_vm._v("付款順序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("條件")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("所需準備時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐間隔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("準備時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("取餐方式/門檻")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("外送類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("支援")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("開啟")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("預設")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("店家取餐ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("最低消費門檻")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("距離門檻")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("送餐方式")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訪客下單\t")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐提醒")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("外送門檻排除指定商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("運費設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n                    POS廠商ID\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("訂單金額")]), _vm._v(" "), _c('td', [_vm._v("運費設定")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("運送距離")]), _vm._v(" "), _c('td', [_vm._v("運費設定")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("運送距離")]), _vm._v(" "), _c('td', [_vm._v("訂單金額")]), _vm._v(" "), _c('td', [_vm._v("運費設定")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("桌號設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("星期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("營業時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訂購時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("指定時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("營業時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訂購時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("備註")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("辨識碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("出單機啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定機啟用")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('h3', [_vm._v("排除商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連線狀態")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("自選吸管或餐具功能")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("未設定")])])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("預設吸管或餐具選項")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("未設定")])])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true",
      "id": "ad-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("廣告")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "https://s3-ap-northeast-1.amazonaws.com/matcher-images-beta/banner/milkshop_0502_w_002.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control form-info text-wrap",
    staticStyle: {
      "min-width": "224px"
    }
  }, [_vm._v("\n                https://beta-matcher-testing-web.soonsource.com/#/menu/12\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("星期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("營業時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("訂購時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("外送類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("店家取餐ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("最低消費門檻")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("距離門檻")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("店家付款ID")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("所需準備時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("取餐間隔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example",
      "tabindex": "0"
    }
  }, [_vm._v("連線狀態")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89eab82c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/StoreInfo.vue
// module id = 2512
// module chunks = 1